const imageUrl = 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20an%20open%20laptop%20displaying%20organized%20spreadsheet%20interface%2C%20neatly%20arranged%20fashion%20catalog%20prints%20and%20a%20coffee%20cup%2C%20warm%20natural%20morning%20light%20streaming%20through%20a%20window%2C%20cream%20colored%20walls%2C%20light%20oak%20wooden%20desk%20surface%2C%20small%20potted%20succulent%20plant%2C%20editorial%20productivity%20lifestyle%20photography%2C%20soft%20gentle%20shadows%2C%20warm%20golden%20amber%20tones%2C%20organized%20yet%20lived-in%20feel&width=800&height=600&seq=vigorbuy-whatis-2026-v3&orientation=landscape';

export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full order-2 lg:order-1">
            <div
              className="w-full aspect-[4/3] rounded-lg bg-cover bg-center"
              style={{
                backgroundImage: `url('${imageUrl}')`,
              }}
            />
          </div>

          <div className="flex-1 order-1 lg:order-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-information-line w-3.5 h-3.5 flex items-center justify-center"></i>
              What Is This
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              What Is VigorBuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              VigorBuy Spreadsheet helps buyers organize products, compare options, review quality checks,
              and discover trusted resources before making purchasing decisions. Our guides provide updated
              information, tutorials, safety tips, and detailed comparisons to help users navigate VigorBuy efficiently.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Whether you are browsing Shoes, Jackets, Accessories, or any of our 14 curated categories,
              each section connects you directly to verified product selections with organized information
              that makes comparison shopping straightforward and informed.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}